import Empty from '@/assets/placeholders/empty.png';
import { EMPTY_WHITE_LABEL_STRING } from '@/common/constants';

import { CoinChartColorType, WhiteLabelTheme } from '../types';

import CardBackground from './assets/card-background.svg';
import CardLogo from './assets/card-logo.svg';
import DashboardBanner from './assets/dashboard-banner.svg';
import LoginBackground from './assets/login-background.svg';
import LogoIcon from './assets/logo.svg';
import manageProfileBanner from './assets/manageProfileBanner.svg';
import SmallLogoIcon from './assets/minify-logo.svg';
import ReimburseMeSidebarBackground from './assets/reimburseMe-sidebar-background.svg';
import SignInLogo from './assets/signIn-logo.svg';
import VerificationBanner from './assets/verificationBackground.svg';

const buttonColors = {
  buttonPrimary: '#0A8080',
  buttonPrimaryHover: '#005961',
  buttonPrimaryActive: '#02474E',
  buttonPrimaryPressed: '#02474E', //
  buttonPrimaryDisabled: '#E5E9F0', //

  buttonSecondaryHoverBorder: '#0A8080',
  buttonSecondaryActiveBorder: '#02474E',
  buttonSecondaryDisabledBorder: '#E5E9F0', //
  buttonSecondaryDisabled: '#FFFFFF', //
  buttonSecondaryHover: '#E8F0F3', //

  buttonTertiaryHover: '#E8F0FE', //
  buttonTertiaryPressed: '#B7D1FC', //
  buttonTertiaryDisabled: '#E5E9F0', //

  buttonSecondaryContainer: '#EAFFFF',

  // button: '#0A8080',
  // buttonHover: '#005961',
  // buttonActive: '#02474E',
  // buttonSecondary: '#0A8080',
  // buttonSecondaryActive: '#02474E',

  // button: -> buttonPrimary
  // buttonHover -> buttonPrimaryHover
  // buttonActive -> buttonPrimaryActive
  // buttonSecondary -> buttonSecondaryHoverBorder
  // buttonSecondaryContainer -> transparent
  // buttonSecondaryActive -> buttonSecondaryActiveBorder
};
const navigationColors = {
  navigationBackground: '#005961',
  navigationBorder: '#24666B',
  navigationAccent: '#0A8080',
  navigationAccent2: '#0A8080',
  navigationTextDefault: '#FFFFFF',
  navigationTextAccent: '#FFFFFF',
  navigationIconDefault: '#FFFFFF',
  navigationIconAccent: '#FFFFFF',
  navigationAccentHover: '#0A8080',
  navigationAccentActive: '#0A8080',
};
const backgroundColors = {
  background1: '#005961',
  background2: '#005961',
  background3: '#000000',

  border: '#BABABC',
  border1: '#DCDCDC',
  border2: '#EAEAEA',
  module: '#FBFAFA',
  canvas: '#FFFFFF',
  stressContainer: '#12284B',
  accentActive: '#0A8080',
  accentBorder: '#BABABC',
  accentContainer: '#CBE2E2',
  popupBg2: '#0F16210D',
  legend: '#E2E2E2',
};
const baseColors = {
  ...buttonColors,
  ...navigationColors,
  ...backgroundColors,

  textTitle: '#222525',
  textBody: '#000000',

  textSecondary: '#6B7485',
  textDisabled: '#9BA3B3',
  textOnColor: '#FFFFFF',
  textAccent: '#0A8080',
  textAccentHover: '#005961',
  textAccentActive: '#02474E',

  iconPrimary: '#000000',
  iconSecondary: '#B8BFCC',
  iconOnColor: '#FFFFFF',
  iconAccent: '#0A8080',
  iconAccentHover: '#005961',
  iconAccentActive: '#02474E',
  iconDisabled: '#9BA3B3',

  success: '#0A8080',
  successBorder: '#6FD1D1',
  successContainer: '#E1FFFF',
  sidebarDelimiter: '#ECECEC',
  warning: '#B88023',
  warningBorder: '#FED188',
  warningContainer: '',

  danger: '#D5351F',
  dangerBorder: '#FF9A8D',
  dangerContainer: '#FFE0DC',
  dangerHover: '#C32009',
  dangerActive: '#9E2717',

  info: '#176AF6',
  infoBorder: '#B7D1FC',
  infoContainer: '#E8F0FE',

  transactionDental: '#176AF6',
  transactionVision: '#481A54',
  transactionMedical: '#00C3B3',
  transactionOther: '#FF9D0A',
  transactionParking: '#323D9B',
  transactionTransit: '#9BBF84',
  transactionAdoption: '#0F7970',
  transactionDependentCare: '#CC3381',
  transactionPharmacy: '#D83B00',
  transactionLifestyle: '#D3375C',
  transactionPremium: '#3628D1',
  transactionTravel: '#F26B31',
  transactionWellness: '#9B31F2',
  transactionPlanSpecific: '#00B5EE',
  refund: '#588C0E',
  transactionDefault: '#5E697E',
  claimTransferInternal: '#E5E9F0',
  nonClaimIcon: '#151F6D',
  nonClaimBg: '#E5E9F0',

  planTypeHSA: '#2EA12B',
  planTypeHCFSA: '#FA802A',
  planTypeDCAP: '#CC3381',
  planTypeHRA: '#134E8F',
  planTypeCommuterTransit: '#9BBF84',
  planTypeCommuterParking: '#323D9B',
  planTypeAdoption: '#0F7970',
  planTypeLifestyle: '#D3375C',
  planTypeSpecialty: '#00B5EE',
  planTypeTravel: '#F26B31',
  planTypeRx: '#7909AD',
  planTypeDental: '#176AF6',
  planTypeVision: '#481A54',
  planTypeMedical: '#00C3B3',

  lockedNull: '#000000',
  processingPending: '#F9C134',
  needsHelp: '#FF9D0A',
  paidActiveComplete: '#0A8080',
  partiallyPaid: '#B9CC29',
  waitingForFunds: '#8EB2A1',
  deniedErrorExpired: '#E72626',
  uploading: '#9BA3B3',
  uploadedApproved: '#176AF6',
  loa: '#00B5EE',
  retirement: '#CE8258',
  future: '#7909AD',

  missingDetail: '#FB6D2A',
  missingContainer: '#FFF3EE',
  missingBorder: '#FEDACA',

  investmentsfuture: '#7909AD',
  investmentsFund1: '#3F68FF',
  investmentsFund2: '#10D8B9',
  investmentsFund3: '#FB5C20',
  investmentsFund4: '#FC990F',
  investmentsFund5: '#FDD137',
  investmentsFund6: '#BCD1EF',
  investmentsFund7: '#323D9B',
  investmentsFund8: '#F3C626',
  investmentsFund9: '#A528C6',
  investmentsFund10: '#0C95D0',
  investmentsFund11: '#619C00',
  investmentsFund12: '#CC3381',
  investmentBackground: '#233636',
  profitContainer: '#00FF9314',
  lossContainer: '#EF235D14',
  chart: '#0A8080',
  coinChart: ['#508A8A', '#F3FFFF', '#6ADEDE', '#F3FFFF', '#7AA6A6'] as CoinChartColorType,

  partner: '#D83B00',
  distributor: '#904D27',
  employer: '#174FBC',
  subsidiary: '#0F7970',
  subgroup: '#481A54',
  claimProcessor: '#176AF6',
  employee: '#0CAD09',
  dependent: '#5E1696',
  noAssignee: '#B8BFCC',

  claimParticipant: '#CC3381',
  claimSystem: '#18A0FB',
  claimCardProcessor: '#19B269',

  uploadLinkBackground: '#0A8080',
};
export default {
  title: 'Gusto',
  loginScreenTitle: EMPTY_WHITE_LABEL_STRING,
  termsAndConditions: 'http://gusto.com/legal/privacy',
  privacyPolicy: 'http://gusto.com/legal/privacy',

  IOSAppLink: 'elevate://open-app',
  androidAppLink: 'elevate://open-app',

  mobileAppIcon: SmallLogoIcon,
  mobileAppTitle: 'Gusto',
  loginIconHeight: 86,
  loginIconWidth: 336,
  isSidebarItemWide: true,
  isLoginFooter: true,
  colors: {
    ...baseColors,
    loginTitleColor: baseColors.textBody,

    popup: 'rgba(15, 22, 33, 0.5)',
    popup2: 'rgba(15, 22, 33, 0.05)',
    fade1: 'linear-gradient(0deg, #F7F9FA 0%, rgba(255, 255, 255, 0.00) 100%)',
    fade2: 'linear-gradient(180deg, #F7F9FA 0%, #EEF1F4 100%)',
  },
  logo: LogoIcon,
  minifyLogo: SmallLogoIcon,
  font: "'GCentra'",
  titleFont: "'GCentra'",
  tetriaryAccentButton: true,

  //wait for design
  images: {
    settingsIllustration: '',
    banner: DashboardBanner,
    cardBackground: CardBackground,
    loginBackground: LoginBackground,
    cardLogo: CardLogo,
    sidebarLogo: LogoIcon,
    sidebarMinifyLogo: SmallLogoIcon,
    qrCodeLogo: SmallLogoIcon,
    investmentsBannerRight: Empty,
    reimburseMeSidebar: ReimburseMeSidebarBackground,
    signUpSidebar: ReimburseMeSidebarBackground,
    verificationBackground: VerificationBanner,
    signInLogo: SignInLogo,
    manageProfileBannerBackground: manageProfileBanner,
  },

  fonts: {
    sidebarWeight: 500,
    sidebarFontSize: '14px',
    reimbursementWeight: 500,
    sizes: {
      small: {
        size: '12px',
        height: '16px',
        maxWidth: '336px',
      },
      '3xl': {
        size: '30px',
        height: '40px',
        maxWidth: '1008px',
      },
      '2xl': {
        size: '24px',
        height: '30px',
        maxWidth: '816px',
      },
    },
  },
  rounds: {
    moduleRound: '12px',
    container1Round: '8px',
    container2Round: '4px',
    checkboxRound: '4px',
    fieldRound: '4px',
    button1Round: '4px',
    button2Round: '2px',
    dropdownItemRound: '2px',
    snackbarRound: '2px',
  },

  shadows: {
    default: '0px 1px 7px rgba(0, 0, 0, 0.10);',
    hover: '0px 3px 10px rgba(0, 0, 0, 0.10);',
    active: '0px 8px 25px rgba(0, 0, 0, 0.25);',
    highlighted: '0px 6px 16px rgba(18, 40, 75, 0.45);',
  },
  favicon: '/gusto/favicon.ico',
  favicon16: '/gusto/favicon-16x16.png',
  favicon32: '/gusto/favicon-32x32.png',
  faviconAppleTouch: '/gusto/apple-touch-icon.png',
} as WhiteLabelTheme;
